var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLastTweetClient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.645,
    height: 78.187,
    viewBox: "0 0 96.645 78.187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lastTweetClient",
    transform: "translate(-135.23 -45.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16713",
    "data-name": "Group 16713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lastTweetClient-2",
    "data-name": "lastTweetClient",
    transform: "translate(-471.02 -164.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11259",
    "data-name": "Path 11259",
    d: "M691.79,229.84c.04.84.06,1.68.06,2.53a54.639,54.639,0,0,1-1.12,10.86,27.819,27.819,0,0,0-35.2,41.43,57.111,57.111,0,0,1-19.14,3.16,55.2,55.2,0,0,1-29.87-8.75A39.337,39.337,0,0,0,635.37,271a19.5,19.5,0,0,1-18.2-13.54,18.682,18.682,0,0,0,3.66.35,19.767,19.767,0,0,0,5.14-.68,19.5,19.5,0,0,1-15.63-19.11v-.25a19.356,19.356,0,0,0,8.82,2.44,19.513,19.513,0,0,1-6.03-26.02,55.31,55.31,0,0,0,40.18,20.36,19.5,19.5,0,0,1,33.21-17.77,38.788,38.788,0,0,0,12.37-4.74,19.546,19.546,0,0,1-8.57,10.79,38.9,38.9,0,0,0,11.2-3.07A39.352,39.352,0,0,1,691.79,229.84Z",
    fill: "rgba(93,169,221,0.2)",
    stroke: "#5da9dd",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11524",
    "data-name": "Path 11524",
    d: "M90,0a20,20,0,1,0,10,2.679A20,20,0,0,0,90,0ZM80.5,13h15a.472.472,0,0,1,.5.5V17h-.5A1.473,1.473,0,0,0,94,18.5V21H80V13.5a.472.472,0,0,1,.5-.5Zm15,5h4a.472.472,0,0,1,.5.5V19H95v-.5A.472.472,0,0,1,95.5,18ZM95,20h5v6H95ZM80,22H94v2H80.5a.472.472,0,0,1-.5-.5Zm8,.5a.5.5,0,1,0,.5.5A.472.472,0,0,0,88,22.5ZM87,25h2v2h3.75a.5.5,0,1,1,0,1h-9.5a.5.5,0,1,1,0-1H87Zm8,2h5v.5a.472.472,0,0,1-.5.5h-4a.472.472,0,0,1-.5-.5Z",
    transform: "translate(119.002 83)",
    fill: "rgba(93,169,221,0.15)",
    stroke: "#5da9dd",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastTweetClient);
export default __webpack_public_path__ + "static/media/lastTweetClient.4bef664072bbd7f76671e8c1ae0d1d5b.svg";
export { ForwardRef as ReactComponent };